import { render, staticRenderFns } from "./NormalCard.vue?vue&type=template&id=171906fd&scoped=true"
import script from "./NormalCard.vue?vue&type=script&lang=js"
export * from "./NormalCard.vue?vue&type=script&lang=js"
import style0 from "./NormalCard.vue?vue&type=style&index=0&id=171906fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171906fd",
  null
  
)

export default component.exports